/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Injectable } from '@angular/core';
import {AuthService} from "../auth-service";
import {DataReference} from "../../shared/DataReference";
import {ReplaySubject} from "rxjs/ReplaySubject";
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";
import {FirebaseApp} from "angularfire2";


@Injectable()
export class VotingServiceProvider {

  constructor(private authService: AuthService,
              private firebase: FirebaseApp) {
    console.log('Hello VotingServiceProvider Provider');
  }

  getVoteOptionsForEvent(eventId: string) : Observable<EventVotingOption[]> {

    const subject: Subject<EventVotingOption[]> = new ReplaySubject();

    console.log(DataReference.getVotingOptionsForEventRef(eventId));

    this.firebase.database().ref(DataReference.getVotingOptionsForEventRef(eventId))
      .orderByChild(DataReference.VOTING_IS_ACTIVE).equalTo(true)
      .on(DataReference.Value, snapshot => {

        if (snapshot.exists() && snapshot.hasChildren()) {

          console.log('voting options exist');

          let results: EventVotingOption[] = [];

          snapshot.forEach(child => {
            let val = child.val();
            const result: EventVotingOption = {
              votingId: child.key,
              title: val.title,
              eventId: eventId,
              description: val.description,
              isOpen: val.isOpen,
              isVisible: val.isVisible
            };
            results.push(result);
            return false;
          });

          console.log(results);

          subject.next(results);

        } else {
          console.log('No voting options found');
          subject.next([]);
        }

    }, err => {
        console.error(err);
        subject.error('Error getting voting options');
        subject.complete();
      });

    return subject.asObservable();
  }

  voteForEntry(userVote: UserVote) : Observable<boolean> {

    let subject: Subject<boolean> = new ReplaySubject();

    // check if user id was passed
    let userId: string = userVote.userId;
    if (!userId) {
      userId = this.authService.getCurrentUserId();
    }

    // check if user id was fixed
    if (!userId) {
      subject.error('User is not logged in');
      subject.complete();
    } else {
      let data = {};

      // event node
      data[DataReference.getEventVoteRef(userVote.votingId, userVote.eventId, userVote.entryId, userId)] = userVote.comment || 'No comments';

      this.firebase.database().ref().update(data, err => {
        if (err) {
          console.error(err);
          subject.error('Error sending vote');
          subject.complete();
        } else {
          subject.next(true);
          subject.complete();
        }
      });
    }

    return subject.asObservable();
  }

  // getVoteForEventEntry(eventId: string, entryId: string) {
  //   let subject: Subject<UserVote> = new ReplaySubject();
  //
  //   const userId = this.authService.getCurrentUserId();
  //   if (!userId) {
  //     subject.error('User not logged in');
  //     subject.complete();
  //   } else {
  //
  //     firebase.database().ref(DataReference.getEventVoteRef(eventId))
  //       .orderByChild(`${entryId}/${userId}`).equalTo(userId)
  //       .once(DataReference.Value, snapshot => {
  //         if (snapshot.exists() && snapshot.hasChildren()) {
  //
  //           let results: UserVote[] = [];
  //
  //           snapshot.forEach(child => {
  //             results.push({
  //               votingId: child.
  //             })
  //             return false;
  //           });
  //
  //           let userVote: UserVote = {
  //             votingId: snap
  //           }
  //
  //         } else {
  //           subject.next(null);
  //           subject.complete();
  //         }
  //       });
  //
  //   }
  //
  //   return subject;
  // }

}

// export class EventVotingOption {
//   votingId: string
//   title: string
//   description: string
//   isOpen: boolean
//   isVisible: boolean
// }

export interface EventVotingOption {
  votingId: string,
  eventId: string,
  title: string,
  description: string,
  isOpen: boolean,
  isVisible: boolean,
}

export interface UserVote {
  votingId: string,
  eventId: string,
  entryId: string,
  userId?: string,
  comment?: string
}



// WEBPACK FOOTER //
// ./src/providers/voting-service/voting-service.ts